import React, { PropTypes } from 'react';
import { NitroParagraph, NitroHeading } from 'nitro-components';
import QuoteApproverNote from './QuoteApproverNote';

import Status from '../../../../components/utils/Status';
import { formatStatus, sortHistoryDescending } from '../helper';
import moment from 'moment';

import styled from 'styled-components';

import { QuoteListContainer, QuoteList, QuoteListItem, ListContent } from './QuoteList';

const ApproverInfo = styled.section`
  width: 100%;
`;

const QuoteApprovalHistory = ({ workflowDetails, currentApprover, totalApprovers }) => {
  const workflowDetailsSorted = sortHistoryDescending(workflowDetails);

  let list = workflowDetailsSorted.map((item, index) => {
    if (!item.Status || item.Status.Id === 5) {
      return null;
    }

    return (
      <QuoteListItem key={index}>
        <ListContent>
          <Status layout="horizontal" iconSize="20" labelSize="4" {...formatStatus(item.Status, item.Status, true)} />
          <ApproverInfo>
            <NitroParagraph size="4" noMargin align="right">
              {item.ApproverName}
            </NitroParagraph>
            <NitroParagraph size="5" variant="base3" noMargin align="right">
              {moment(item.ActionedDate).format('Do MMM YYYY').toString()}
            </NitroParagraph>
          </ApproverInfo>
        </ListContent>
        {item.Notes && <QuoteApproverNote note={item.Notes} />}
      </QuoteListItem>
    );
  });

  return (
    <div>
      <NitroHeading
        label={`You are approver ${currentApprover} of ${totalApprovers}`}
        size="4"
        variant="base3"
        align="center"
      />
      {currentApprover > 1 &&
        <QuoteListContainer>
          <QuoteList>
            {list}
          </QuoteList>
        </QuoteListContainer>}
    </div>
  );
};

QuoteApprovalHistory.propTypes = {
  workflowDetails: PropTypes.array,
  currentApprover: PropTypes.number,
  totalApprovers: PropTypes.number
};

export default QuoteApprovalHistory;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteApprovalHistory.js